var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.605 24.6676V44.3325C60.605 47.5525 58.88 50.5426 56.0913 52.1814L39.0138 62.0426C36.225 63.6526 32.775 63.6526 29.9575 62.0426L12.88 52.1814C10.0913 50.5714 8.36627 47.5813 8.36627 44.3325V24.6676C8.36627 21.4476 10.0913 18.4575 12.88 16.8187L29.9575 6.9575C32.7463 5.3475 36.1963 5.3475 39.0138 6.9575L56.0913 16.8187C58.88 18.4575 60.605 21.4188 60.605 24.6676Z",
    fill: "#314DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 34.5009C38.1996 34.5009 41.1987 31.5018 41.1987 27.8021C41.1987 24.1025 38.1996 21.1035 34.5 21.1035C30.8003 21.1035 27.8012 24.1025 27.8012 27.8021C27.8012 31.5018 30.8003 34.5009 34.5 34.5009Z",
    fill: "#314DDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.205 47.8977C44.5337 47.8977 45.885 45.3104 44.5912 43.3841C42.6362 40.4804 38.8412 38.5254 34.5 38.5254C30.1587 38.5254 26.3637 40.4804 24.4087 43.3841C23.115 45.3104 24.4662 47.8977 26.795 47.8977H42.205Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c18413c3e6d70c5acb1df8aca6b20106.svg";
export { ForwardRef as ReactComponent };